import { ICommonIconProps } from "../interface";

const CardArrowIcon = ({ IconColor }: ICommonIconProps) => {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 11.5L11.5 1.5M11.5 1.5H1.5M11.5 1.5V11.5"
        stroke={IconColor || "currentColor"}
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default CardArrowIcon;
